import { useEffect, useMemo, useState } from 'react';
import { Box, Chip, TextField, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { post } from 'api';
import dayjs from 'dayjs';
import useNumberFormat from 'hooks/useNumberFormat';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';

// import DataGridPagination from 'components/pagination/DataGridPagination';

const UserAttendance = ({ state, total }) => {
  const { currencyFormat } = useNumberFormat();

  const [data, setData] = useState([]);
  const [value, setValue] = useState(dayjs().format('YYYY-MM'));
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const columns = useMemo(
    () => [
      {
        field: 'date',
        headerName: 'Date',
        filterable: false,
        sortable: false,
        minWidth: 170,
        renderCell: (params) => {
          const { date } = params.row;
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {date}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'punchIn',
        headerName: 'Punch In',
        filterable: false,
        sortable: false,
        minWidth: 150,
        renderCell: (params) => {
          const { loginTime } = params.row;

          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {loginTime ? moment(loginTime).format('HH:mm A') : '-'}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'punchOut',
        headerName: 'Punch Out',
        filterable: false,
        sortable: false,
        minWidth: 150,
        renderCell: (params) => {
          const { logoutTime } = params.row;

          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {logoutTime ? moment(logoutTime).format('HH:mm A') : '-'}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'workingHour',
        headerName: 'Working Hour',
        filterable: false,
        sortable: false,
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          const { workingHour } = params.row;

          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {workingHour ? `${workingHour} h` : '00'}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'status',
        headerName: 'Status',
        filterable: false,
        sortable: false,

        minWidth: 150,
        renderCell: (params) => {
          const { status } = params.row;
          return (
            <Box>
              <Chip
                size="small"
                label={status || '-'}
                color={status == 'Present' ? 'success' : status == 'Inprogree' ? 'info' : 'warning'}
                variant="outlined"
              />
            </Box>
          );
        },
      },
    ],
    [currencyFormat],
  );

  const fetchData = async () => {
    try {
      const res = await post('users/getHistory', { userAttendanceId: state._id, month: value });
      if (res.status == 200) {
        setData(res.data);
      } else {
        enqueueSnackbar(res.message || 'Error while fetching User Attendance', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while fetching User Attendance', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, [value]);
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ py: 2, width: '40%' }}>
        <TextField
          type="month"
          variant="filled"
          fullWidth
          label="Month Of Attendance"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          slotProps={{
            htmlInput: {
              min: '2025-11',
              max: dayjs().format('YYYY-MM'),
            },
          }}
        />
      </Box>
      <Box sx={{ overflowY: 'auto', overflowX: 'auto' }}>
        <DataGrid
          rowHeight={72}
          rows={data}
          columns={columns}
          getRowId={(row) => row._id}
          pagination
          // paginationMode="server"
          rowCount={total}
          paginationModel={paginationModel} // { page: 0, pageSize: 10 }
          onPaginationModelChange={(e) =>
            setPaginationModel({ page: e.page, pageSize: e.pageSize })
          }
          pageSizeOptions={[5, 10, 20]}
          sx={{
            '& .margin': {
              pr: 3,
            },
            '& .MuiDataGrid-columnHeaders': {
              minWidth: '100%',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default UserAttendance;
